// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function applyPagination(data: any, page: number, rowsPerPage: number) {
	return data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
}
